import { InputField } from "@/components/shared/fields/InputField/InputField";
import { PasswordField } from "@/components/shared/fields/PasswordField/PasswordField";
// import { useSession } from '@/hooks/use-session';
// import { ILoginData, login } from '@/mutations/auth';
// import { getErrors } from '@/utils/form-error';
import { BoxProps, Button, Checkbox, HStack, Stack } from "@chakra-ui/react";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface ISignUpFormValues {
  email: string;
  password: string;
  passwordCheck: string;
}

export const SignUpForm: FC<BoxProps> = props => {
  const { t } = useTranslation("signup-form");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError
  } = useForm<ISignUpFormValues>();
  // const { mutate } = useSession();
  // const client = useClient();

  async function onSubmit(formData: ISignUpFormValues) {
    // try {
    // 	const data: ILoginData = {
    // 		type: 'sessions',
    // 		attributes: formData,
    // 	};
    // 	await mutate(() => login(client, { data }), false);
    // } catch (errors) {
    // 	if (errors instanceof Response) {
    // 		getErrors(errors.error).forEach(({ name, type, message = t('error') }) => {
    // 			if (name === 'email' || name === 'password') {
    // 				setError(name, { type, message });
    // 			}
    // 		});
    // 	}
    // }
  }
  return (
    <Stack
      as="form"
      noValidate
      onSubmit={handleSubmit(onSubmit)}
      spacing="6"
      {...props}
    >
      <Stack spacing="5">
        <InputField
          id="email"
          label={t("Email")}
          errors={errors}
          type="email"
          {...register("email", {
            required: t("required"),
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: t("Entered value does not match email format")
            }
          })}
        />
        <PasswordField
          label={t("Password")}
          errors={errors}
          id="password"
          {...register("password", { required: t("required") })}
        />
        <PasswordField
          label={t("Password Check")}
          errors={errors}
          id="passwordCheck"
          {...register("passwordCheck", { required: t("required") })}
        />
      </Stack>
      {/* <HStack justify="space-between">
        <Checkbox color="black" colorScheme="red" defaultChecked>
          Remember me
        </Checkbox>
        <Button colorScheme="red" size="sm" variant="link">
          Forgot password?
        </Button>
      </HStack> */}
      <Stack spacing="6">
        <Button colorScheme="red" type="submit">
          {t("sign up")}
        </Button>
      </Stack>
    </Stack>
  );
};
